import React from "react";
import { WordStats as WordStatsType } from "../../../types";
import "./WordStats.css";

interface WordStatsProps {
  wordStats: WordStatsType[];
}

export const WordStats: React.FC<WordStatsProps> = ({ wordStats }) => {
  return (
    <div className="word-stats">
      <h3 className="word-stats__title">Ausgewählt</h3>
      <div className="word-stats__list">
        {wordStats.length === 0 ? (
          <div className="word-stats__empty">Noch nichts ausgewählt</div>
        ) : (
          wordStats.map((stat, index) => (
            <div key={index} className="word-stats__item">
              <span className="word-stats__word">{stat.text}</span>
              <span className="word-stats__count">{stat.clickCount}x</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
